import { Trans, useTranslation } from 'react-i18next';
import { FooterHeader, FooterWrapper } from './BillingReminderFooter.StyledComponents';

export const BillingReminderFooter = () => {
    const { t } = useTranslation('billingReminder');
    return (
        <div>
        <FooterHeader>{t('footer.header')}</FooterHeader>
        <FooterWrapper>
            <span>
                <Trans
                    ns="billingReminder"
                    i18nKey="footer.triumphAddress"
                    components={{
                        bold: <b></b>,
                        break: <br />
                     }}
                />
            </span>
            <span>
                <Trans
                    ns="billingReminder"
                    i18nKey="footer.wellsAddress"
                    components={{
                        bold: <b></b>,
                        break: <br />
                    }}
                />
            </span>
        </FooterWrapper>
        </div>
    );
};